<template>
  <div>
    <v-dialog v-model="dialog" max-width="80%">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title> Ajouter une pièce jointe </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap xs12>
              <v-flex xs5>
                <v-combobox
                  class="pt-0"
                  v-model="editedItem.NomDocument"
                  label="Type de pièce"
                  item-text="Lang00"
                  item-value="Id"
                  :title="editedItem.NomDocument"
                  readonly
                >
                </v-combobox>
              </v-flex>
              <v-flex xs6>
                <!--cutom update button AGU-->
                <upload-btn
                  class="mr-10"
                  color="secondary"
                  :loading="uploadFileLoading"
                  :selectedFileName="this.editedItem.NomFichier"
                  defaultButtonText="Sélectionner votre document"
                  ref="btnupload"
                  :acceptFormats="['pdf']"
                  @file-update="selectFile"
                >
                </upload-btn>
                <small
                  >{{ $storeUm6p.Label.Annexes.FormatsAcceptesPdf }}</small
                >
                <br />
                <small>Taille maximum du fichier : 8Mo</small>

                <v-snackbar
                  :timeout="2000"
                  color="error"
                  elevation="24"
                  v-model="snackbar"
                >
                  Taille maximale du fichier dépassée.
                </v-snackbar>
              </v-flex>
              <v-flex xs1> </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
              <span v-if="editedItem.NomFichier">Fichier Sélectionné : </span>
              <span
                v-if="editedItem.NomFichier"
                style="background-color: lightgray"
                >{{ editedItem.NomFichier }}</span
              >
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="close">Annuler</v-btn>
          <v-btn color="success" dark :loading="uploadFileLoading" @click="save"
            >Valider</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <h2 v-if="!creation">LISTE DES PIECES JOINTES A FOURNIR</h2>
    <v-data-table
      v-show="!creation"
      :headers="headers"
      :items="annexesNormales"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" :icon="icons.mdiAlert"
          >La liste est vide</v-alert
        >
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <th class="text-xs-left">
            {{ item.LabelFormulaire }}
          </th>
          <th class="text-xs-left" style="color: red" v-if="!item.NomFichier">
            Fichier manquant
          </th>
          <th class="text-xs-left" v-else>
            {{ item.NomFichier }}
          </th>
          <th>
            {{ item.ObligatoireSoumettre ? "Oui" : "Non" }}
          </th>
          <th
            class="text-xs-left"
            style="color: red"
            v-if="
              item.ConformiteElectronique.Id == 4251 ||
              item.ConformiteElectronique.Id == 4299
            "
          >
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th class="text-xs-left" v-else>
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th>
            {{ item.NonConformeElectronique }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.Valide"
              v-show="item.Editable"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.UrlFichier"
              small
              class="mr-2"
              title="Afficher le document"
              @click="$storeCommun.AfficherAnnexe(item.UrlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.NomFichier && item.Editable"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
    
    <br />
    <h3 v-if="annexesAnneeAnterіeure && annexesAnneeAnterіeure.length > 0">{{ 'Les attestations de scolarité pour tranches de paiement' }}</h3>
    <v-data-table
      :headers="headers"
      v-show="annexesAnneeAnterіeure && annexesAnneeAnterіeure.length > 0"
      :items="annexesAnneeAnterіeure"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" :icon="icons.mdiAlert"
          >La liste est vide</v-alert
        >
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <th class="text-xs-left">
            {{ item.LabelFormulaire }}
          </th>
          <th class="text-xs-left" style="color: red" v-if="!item.NomFichier">
            Fichier manquant
          </th>
          <th class="text-xs-left" v-else>
            {{ item.NomFichier }}
          </th>
          <th>
            {{ item.ObligatoireSoumettre ? "Oui" : "Non" }}
          </th>
          <th
            class="text-xs-left"
            style="color: red"
            v-if="
              item.ConformiteElectronique.Id == 4251 ||
              item.ConformiteElectronique.Id == 4299
            "
          >
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th class="text-xs-left" v-else>
            {{ item.ConformiteElectronique.Lang00 }}
          </th>
          <th>
            {{ item.NonConformeElectronique }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.Valide"
              v-show="item.ConformiteElectronique.Id !== $storeCatalogue.DataId.Conforme && item.ConformiteElectronique.Id !== $storeCatalogue.DataId.AnnexeAVerifier"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.UrlFichier"
              small
              class="mr-2"
              title="Afficher le document"
              @click="$storeCommun.AfficherAnnexe(item.UrlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.NomFichier && (item.ConformiteElectronique.Id !== $storeCatalogue.DataId.Conforme && item.ConformiteElectronique.Id !== $storeCatalogue.DataId.AnnexeAVerifier)"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  mdiPencil,
  mdiEye,
  mdiClose,
  mdiDelete,
  mdiAlert,
  mdiFileDownload,
} from "@mdi/js";
import UploadButton from "@/components/CustomFileUpload";

export default {
  components: {
    "upload-btn": UploadButton,
  },
  props: {
    creation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiEye,
        mdiClose,
        mdiDelete,
        mdiFileDownload,
        mdiAlert,
      },
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCommun:this.$storeCommun,
      $storeCatalogue: this.$storeCatalogue,
      // Dialog et flag
      dialog: false,
      uploadFileLoading: false,
      snackbar: false,

      //Header list
      headers: [
        { text: "Type de pièce", value: "type" },
        { text: "Fichier", value: "fichier" },
        { text: "Obligatoire", value: "obligatoire" },
        {
          text: "Conformité électronique",
          value: "conformiteelectronique",
          sortable: false,
        },
        { text: "Notes", value: "noteconformiteelectronique", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],

      editedIndex: -1,
      editedItem: {
        Supprimer: false,
        IdCrypte: null,
        Editable: false,
        AnneeScolaire: {
          Id: null,
          Lang00: null,
        },
        ConformiteElectronique: {
          Id: null,
          Lang00: null,
        },
        ConformitePhysique: {
          Id: null,
          Lang00: null,
        },
        NatureDocument: {
          Id: null,
          Lang00: null,
        },
        NomDocument: {
          Id: null,
          Lang00: null,
        },
        NomFichier: null,
        DonneePieceJointe: null,
        NonConformeElectronique: null,
        NonConformePhysique: null,
        DossierBourseId: null,
        PpId: null,
        TemplateAnnexeFirsi: null,
        TypeDeDocument: {
          Id: null,
          Lang00: null,
        },
      },

      pieceManquante: 1,
      index: 0,
    };
  },
  mounted() {
    this.$storeCatalogue.ChargerCataloguesAnnexes();
  },
  computed: {
    annexesNormales() {
      const idsAnneeAnterieure = [
        this.$storeCatalogue.DataId.Document2emeTranche,
        this.$storeCatalogue.DataId.Document3emeTranche
      ];
      return this.$storeDossierBourse.ListeAnnexesFirsi.filter(
        item => !idsAnneeAnterieure.includes(item.NomDocument.Id)
      );
    },
    annexesAnneeAnterіeure() {
      const idsAnneeAnterieure = [
        this.$storeCatalogue.DataId.Document2emeTranche,
        this.$storeCatalogue.DataId.Document3emeTranche
      ];
      return this.$storeDossierBourse.ListeAnnexesFirsi.filter(
        item => idsAnneeAnterieure.includes(item.NomDocument.Id)
      );
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex =
        this.$storeDossierBourse.ListeAnnexesFirsi.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer ce fichier ?")) {
        // on récupère l'item depuis le store
        this.editedIndex =
          this.$storeDossierBourse.ListeAnnexesFirsi.indexOf(item);
        // on affecte l'item local pour récupèrer les valeurs
        this.editedItem = Object.assign({}, item);

        var self = this;
        Promise.all([
          // Appel de l'api de suppression de la PJ
          this.$storeDemandeBourse
            .DeleteFichier(
              this.editedItem,
              this.$storeDossierBourse.TokenExtranet
            )
            .then((reponse) => {
              if (reponse) {
                this.ParseDtoToEditedItem(reponse.data);
                Object.assign(
                  this.$storeDossierBourse.ListeAnnexesFirsi[this.editedIndex],
                  this.editedItem
                );
              }
            })
            .catch((error) => {
              console.log(error);
            }),
        ]).then(function () {
          // RAZ de editeditem
          self.close();
        });
      }
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size > 8388608) {
          this.editedItem.NomFichier = "";
          this.editedItem.DonneePieceJointe = null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.editedItem.NomFichier = file.name;
          await this.readFile(file, this.editedItem);
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.editedItem.NomFichier = "";
        this.editedItem.DonneePieceJointe = null;
      }
    },

    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du fichier

      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign(
          {},
          {
            Supprimer: false,
            IdCrypte: null,
            Editable: false,
            AnneeScolaire: {
              Id: null,
              Lang00: null,
            },
            ConformiteElectronique: {
              Id: null,
              Lang00: null,
            },
            ConformitePhysique: {
              Id: null,
              Lang00: null,
            },
            NatureDocument: {
              Id: null,
              Lang00: null,
            },
            NomDocument: {
              Id: null,
              Lang00: null,
            },
            NomFichier: null,
            DonneePieceJointe: null,
            NonConformeElectronique: null,
            NonConformePhysique: null,
            DossierBourseId: null,
            PpId: null,
            TemplateAnnexeFirsi: null,
            TypeDeDocument: {
              Id: null,
              Lang00: null,
            },
          }
        );
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        var self = this;
        this.uploadFileLoading = false;
        this.editedItem.Supprimer = false;
        Promise.all([
          // Sauvegarder le fichier, appelle api
          this.$storeDemandeBourse
            .UploadFichier(
              this.editedItem,
              this.$storeDossierBourse.TokenExtranet
            )
            .then((reponse) => {
              if (reponse && reponse.data) {
                this.ParseDtoToEditedItem(reponse.data);
                Object.assign(
                  this.$storeDossierBourse.ListeAnnexesFirsi[this.editedIndex],
                  this.editedItem
                );
              } else {
                console.log("annexe pas enregistrée");
              }
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            }),
        ]).then(function () {
          self.close();
          self.$refs.btnupload.resetClick();
        });
      }
    },
    ParseDtoToEditedItem(dto) {
      this.editedItem = this.$storeDossierBourse.ElementToAnnexesFirsiDto(dto);
    },
  },
};
</script>
